import type * as SchemaTypes from '../types';

import type { NamirialSettingsSpecFragment } from './NamirialSettingsSpec';
import type { SimpleVersioningDataFragment } from './SimpleVersioningData';
import type { AuthorData_CorporateCustomer_Fragment, AuthorData_ExternalBank_Fragment, AuthorData_Guarantor_Fragment, AuthorData_LocalCustomer_Fragment, AuthorData_Salesforce_Fragment, AuthorData_SystemBank_Fragment, AuthorData_User_Fragment } from './AuthorData';
import { gql } from '@apollo/client';
import { NamirialSettingsSpecFragmentDoc } from './NamirialSettingsSpec';
import { SimpleVersioningDataFragmentDoc } from './SimpleVersioningData';
import { AuthorDataFragmentDoc } from './AuthorData';
export type NamirialSigningModuleSpecsFragment = (
  { __typename: 'NamirialSigningModule' }
  & Pick<SchemaTypes.NamirialSigningModule, 'id' | 'displayName'>
  & { namirialSetting: (
    { __typename: 'NamirialSetting' }
    & NamirialSettingsSpecFragment
  ), company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'displayName' | 'timeZone'>
  ), versioning: (
    { __typename: 'SimpleVersioning' }
    & SimpleVersioningDataFragment
  ) }
);

export const NamirialSigningModuleSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment NamirialSigningModuleSpecs on NamirialSigningModule {
  id
  displayName
  namirialSetting {
    ...NamirialSettingsSpec
  }
  company {
    id
    displayName
    timeZone
  }
  versioning {
    ...SimpleVersioningData
  }
}
    `;